import React, { useEffect } from 'react';
import { useTranslation, useI18next } from 'gatsby-plugin-react-i18next';

import * as styles from './style.module.scss';

const {
  playSubscribe,
  playSubscribe__subscribeform,
} = styles;

const PlaySubscribe = ({
  formIdEN = 105,
  formIdDE = 107,
  formTitleEN = "Subscribe to updates",
  formTitleDE = "Jetzt für Updates anmelden"
}) => {
  const { language } = useI18next();
  const { t } = useTranslation();

  useEffect(() => {
    const formId = language === "en" ? formIdEN : formIdDE;
    const formContainer = document.querySelector('.active-campaign-form');

    // Check if the script already exists
    if (!formContainer.querySelector('script')) {
      const script = document.createElement('script');
      script.src = `https://dealfront.activehosted.com/f/embed.php?id=${formId}`;
      script.async = true;

      formContainer.appendChild(script);

      return () => {
        // Cleanup: Remove the script and clear the form content
        if (formContainer) {
          const existingScript = formContainer.querySelector('script');
          if (existingScript) {
            formContainer.removeChild(existingScript);
          }
          formContainer.innerHTML = ''; // Clear any rendered form content
        }
      };
    }
  }, [language, formIdEN, formIdDE]);

  return (
    <section className={`${playSubscribe}`}>
      <div className={`${playSubscribe__subscribeform}`}>
        <div className="active-campaign-form-container background-transparent in-content">
          <h4>{language === "en" ? formTitleEN : formTitleDE}</h4>
          <div className="active-campaign-form">
            <div
              className={language === "en" ? `_form_${formIdEN}` : `_form_${formIdDE}`}
              id="ac-form"
            ></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlaySubscribe;